import React from 'react';
import { Handle, Position } from '@xyflow/react';
import { Box, Typography } from '@mui/material';

const TEMPLATE_CONFIG = {
  execution_rules: { color: '#cc2828', icon: '⚡', label: 'Execution Rules' },
  knowledge_management: { color: '#3a8a5a', icon: '📖', label: 'Knowledge Mgmt' },
  intelligence_guidelines: { color: '#3a6aaa', icon: '🧠', label: 'Guidelines' },
  forms: { color: '#7ab020', icon: '⊟', label: 'Forms' },
};

export default function TemplateNode({ type, data, selected }) {
  const config = TEMPLATE_CONFIG[type] || TEMPLATE_CONFIG.execution_rules;

  return (
    <Box
      sx={{
        position: 'relative',
        border: `2px solid ${config.color}`,
        borderRadius: 2,
        width: 260,
        bgcolor: 'background.paper',
        boxShadow: selected ? `0 0 0 3px ${config.color}44` : 1,
      }}
    >
      <Handle id="target-top" type="target" position={Position.Top} style={{ background: config.color }} />
      <Handle id="target-left" type="target" position={Position.Left} style={{ background: config.color }} />
      <Handle id="source-bottom" type="source" position={Position.Bottom} style={{ background: config.color }} />
      <Handle id="source-right" type="source" position={Position.Right} style={{ background: config.color }} />
      <Box
        sx={{
          px: 1.5,
          py: 0.75,
          bgcolor: `${config.color}22`,
          borderRadius: '6px 6px 0 0',
          display: 'flex',
          alignItems: 'center',
          gap: 1,
        }}
      >
        <Typography sx={{ color: config.color, fontSize: 14 }}>{config.icon}</Typography>
        <Typography
          variant="body2"
          sx={{ fontWeight: 'bold', color: config.color, fontSize: 11, flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
        >
          {data.label || config.label}
        </Typography>
      </Box>
      <Box sx={{ px: 1.5, py: 1 }}>
        <Typography
          variant="caption"
          sx={{
            color: 'text.secondary',
            fontSize: 10,
            display: '-webkit-box',
            WebkitLineClamp: 4,
            WebkitBoxOrient: 'vertical',
            overflow: 'hidden',
          }}
        >
          {data.content || 'Click to edit...'}
        </Typography>
      </Box>
    </Box>
  );
}
